import { isRejected, Middleware } from '@reduxjs/toolkit';
import { reportApiErrorDiagnostics } from '~/helpers/apiErrorDiagnostics.reporter';
import { RejectedRTKAction } from '~/store/middlewares/sentryNotifier/sentryNotifier.type';

// Separate from rtkErrorNotifier and sentryNotifier: their endpoint exclusion lists
// would drop diagnostics for failures that still surface in the UI.
export const apiErrorDiagnosticsMiddleware: Middleware = (store) => (next) => (
  action
) => {
  if (isRejected(action)) {
    const { baseQueryMeta } = (action as RejectedRTKAction).meta;
    const headers = baseQueryMeta?.response?.headers;

    if (headers) {
      reportApiErrorDiagnostics(store.dispatch, headers);
    }
  }

  return next(action);
};
